import styled from 'styled-components';

export const Title = styled.div<{ size?: 'sm' | 'lg' }>`
  font-size: ${props => (props.size === 'lg' ? '14px' : '12px')};
  line-height: ${props => (props.size === 'lg' ? '16.41px' : '12px')};
  font-weight: 500;
  color: #000;
`;

export const InfoValue = styled.span<{ size?: number; lineHeight?: number; black?: boolean }>`
  color: ${props => (props.black ? '#000' : '#757575')};
  font-size: ${({ size = 12 }) => `${size}px`};
  line-height: ${({ lineHeight = 12 }) => `${lineHeight}px`};
  font-weight: 500;
`;

export const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;
